import Component from 'gia/Component'
import eventbus from 'gia/eventbus';
import stage from '../components/stage'
import renderer from '../components/render'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

import { SplitText } from 'gsap/SplitText.js'
gsap.registerPlugin(SplitText);


class Certificates extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.i = 0


    this.ref = {
      title: [],
      partner: [],
      list: null
    }

  }

  mount() {

    this.ref.title.forEach((item, i) => {

        const title = new SplitText(item, {
            type: "words",
            wordsClass: 'word'
        })

        title.words.forEach((item, i) => {
            item.style = `--word-index: ${i}`
        })


        //$(item).addClass('visible')

        ScrollTrigger.create({
          trigger: item,
          start: "top bottom",
          onEnter: ({progress, direction, isActive}) => {
            this.element.classList.add("visible")
          },
          once: true
        });


    })

    ScrollTrigger.create({
          trigger: this.ref.list,
          start: "top bottom",
          onEnter: ({progress, direction, isActive}) => {
            this.ref.list.classList.add("inview")
          },
          once: true
        });


    
}

  unmount() {




  }


}

module.exports = Certificates
